import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'appDigitsGrouping',
  standalone: true,
})
export class DigitsGroupingPipe implements PipeTransform {
  transform(value: number | undefined, cutDecimals = true): string {
    if (value == null || isNaN(value)) return '0';

    // Cut off decimals if the parameter is true
    const formattedValue = cutDecimals ? Math.trunc(value) : value;

    // Convert the number to a string and format it with commas between every 3 digits
    return formattedValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
